// src/pages/WantadDetailsSkeleton.js
import React from "react";

const skeletonItems = Array(3).fill(0);

const MatchesSkeleton = () => (
  <div className="matches-skeleton">
    {skeletonItems.map((_, idx) => (
      <div key={idx} className="matches-skeleton-item">
        <div className="matches-skeleton-img shimmer" />
        <div className="matches-skeleton-content">
          <div className="matches-skeleton-line w-100 shimmer" />
          <div className="matches-skeleton-line w-75 shimmer" />
          <div className="matches-skeleton-line w-50 shimmer" />
        </div>
        <div className="matches-skeleton-actions">
          <div className="matches-skeleton-circle shimmer" />
          <div className="matches-skeleton-circle shimmer" />
        </div>
      </div>
    ))}
  </div>
);

export default MatchesSkeleton;
